/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import CKEditor from 'ckeditor4-react'
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  TextField
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import { categoryFormValidation } from '../../../../../utils/validationSchema'
import { FormLoader } from '../../../../Loader/FormLoader'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../../../../routes'
import { LanguageConsumer } from '../../../../../LanguageContext'

const CategoryForm = ({ currentDate, onSubmit }) => {
  const classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const [isLoading, setIsLoading] = React.useState(true)
  const CategoryForm = useFormik({
    initialValues: {
      name: currentDate.name || '',
      description: currentDate.description || ''
    },
    validateOnMount: true,
    validateOnBlur: false,
    validateOnChange: true,
    validationSchema: categoryFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })

  let errorClass = CategoryForm.errors.description ? ' Mui-error' : ''
  return (
    <form onSubmit={CategoryForm.handleSubmit} noValidate autoComplete="off"
          className={classes.formWrapper}>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Category.Name"> {<FormattedMessage id='Fields.label.CategoryName'/>} </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Category.placeholder.CategoryName' })}
            id="Category.Title"
            type={'text'}
            margin="dense"
            variant="outlined"
            name='name'
            value={CategoryForm.values.name}
            onChange={CategoryForm.handleChange}
            onBlur={CategoryForm.handleBlur}
            helperText={CategoryForm.errors.name && CategoryForm.touched.name && CategoryForm.errors.name}
            error={CategoryForm.errors.name && CategoryForm.touched.name !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Category.Description"> {<FormattedMessage id='Fields.label.PageDescription'/>} </InputLabel>
        <FormControl variant="outlined">
          <LanguageConsumer>
            {({ locale }) => (
              <div className={classes.PageCKContent + errorClass}>
                {!!isLoading && <FormLoader loading={true}/>}
                <CKEditor
                  placeholder={intl.formatMessage({ id: 'Fields.label.PageDescription' })}
                  required
                  fullWidth
                  name='description'
                  variant="outlined"
                  data={CategoryForm.values.description}
                  config={{
                    removeButtons: 'About',
                    language: locale
                  }}
                  onChange={(event, editor) => {
                    CategoryForm.setFieldValue('description', event.editor.getData() ? event.editor.getData() : '' || '')
                  }}
                  onloaded={(event) => {
                    setIsLoading(false)
                  }}
                  onOpen={CategoryForm.handleBlur}
                  helperText={CategoryForm.errors.description && CategoryForm.touched.description && CategoryForm.errors.description}
                  error={CategoryForm.errors.description && CategoryForm.touched.description !== undefined}
                />
                {CategoryForm.errors.description &&
                <FormHelperText error required>{CategoryForm.errors.description}</FormHelperText>
                }
              </div>
            )}
          </LanguageConsumer>
        </FormControl>
      </div>
      <div className={classes.SubmitRow}>
        <button type="submit" disabled={CategoryForm.isSubmitting || !CategoryForm.isValid}
                className={classes.AddAdminSubmit}>
          <FormattedMessage id='AdditionalInfo.button.submit'/>
        </button>
        <Button onClick={() => history.push(NamedRoutes.subscription.category.list)} color="primary">
          <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
        </Button>
      </div>
      {CategoryForm.isSubmitting && <FormLoader loading={true}/>}
    </form>
  )
}

export default CategoryForm
